import { render, staticRenderFns } from "./ProxyConfigModal.vue?vue&type=template&id=896d1c84&scoped=true"
import script from "./ProxyConfigModal.vue?vue&type=script&lang=js"
export * from "./ProxyConfigModal.vue?vue&type=script&lang=js"
import style0 from "./ProxyConfigModal.vue?vue&type=style&index=0&id=896d1c84&prod&scoped=true&lang=css"
import style1 from "./ProxyConfigModal.vue?vue&type=style&index=1&id=896d1c84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896d1c84",
  null
  
)

export default component.exports